import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { LocalStorage } from './localStorage.service';
@Injectable()
export class Global {
  private isCityLoaded: any;
  private static hostApi: any;
  private static cityConfig: any;
  private static dataPool: any;
  constructor(private http: HttpClient) {
    if (!Global.cityConfig) {
      Global.cityConfig = { province: {} };
    }
  }

  private dev(): void {
    Global.hostApi = {};
    Global.hostApi.api = 'http://47.111.151.13:3000/api/';
    // Global.hostApi.api = 'http://localhost:3000/api/';
  }

  private prod(): void {
    Global.hostApi = {};
    Global.hostApi.api = 'http://47.111.151.13:3000/api/';
    // Global.hostApi.api = 'http://localhost:3000/api/';
  }

  init(): void {
    if (this.isDev()) {
      this.dev();
    } else {
      this.prod();
    }
    // this.loadCityConfig();
    // this.socketHandler.init();
  }

  showLogoutDialog(): void {
    // this.dialog
    // 	.open(LogoutDialogComponent)
    // 	.afterClosed()
    // 	.subscribe(result => {
    // 		if (result) {
    // 			this.logout();
    // 		}
    // 	});
  }

  isDev(): boolean {
    // return true;
    return window.location.host.indexOf('www.xiaoyee.tech') === -1;
  }

  getStorageType(): string {
    return 'yuzhou';
  }

  static postData(data: any, name: string) {
    if (!Global.dataPool) {
      Global.dataPool = {};
    }
    Global.dataPool[name] = data;
  }

  static pullData(name: string) {
    let data = undefined;
    try {
      data = JSON.parse(JSON.stringify(Global.dataPool))[name];
      delete Global.dataPool[name];
    } catch (error) { }
    return data;
  }

  static getData(name: string) {
    let data = undefined;
    try {
      data = JSON.parse(JSON.stringify(Global.dataPool))[name];
    } catch (error) { }
    return data;
  }

  static getCityConfig(): any {
    return Global.cityConfig;
  }

  static getApiHost(): any {
    return Global.hostApi;
  }
}
